// extracted by mini-css-extract-plugin
module.exports = {"accordionIcon":"styles_accordionIcon__2-f3F","headerTitle":"styles_headerTitle__3yWYq","accordionHeader":"styles_accordionHeader__14p1A"};